import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import Keycloak from "keycloak-js";
import axios from "axios";
import router from "./router";
import VueSocketIOExt from "vue-socket.io-extended";
import { io } from "socket.io-client";

Vue.config.productionTip = false;

// Check if maintenance mode is enabled
const maintenanceMode = process.env.VUE_APP_MAINTENANCE_MODE === 'true';

if (maintenanceMode) {
  // If in maintenance mode, mount app without authentication
  new Vue({
    vuetify,
    router,
    render: (h) => h(App),
  }).$mount("#app");
} else {
  const keycloak = new Keycloak({
    url: process.env.VUE_APP_KC_URL,
    realm: process.env.VUE_APP_KC_REALM,
    clientId: process.env.VUE_APP_KC_CLIENT_ID,
  });

  Vue.prototype.$keycloak = keycloak;

  const tokenInterceptor = () => {
    axios.interceptors.request.use(
      (config) => {
        config.headers.Authorization = `Bearer ${keycloak.token}`;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  };

  keycloak
    .init({ onLoad: "login-required", checkLoginIframe: false })
    .then(async () => {
      if (
        window.location.href.indexOf("https://hr-io.heig-vd.ch/files") === -1 &&
        !keycloak.hasResourceRole("admin", process.env.VUE_APP_KC_CLIENT_ID)
      ) {
        keycloak.logout();
      } else {
        tokenInterceptor();
        try {
          const { data } = await axios({
            method: "get",
            url: `${process.env.VUE_APP_API_URI}/socket-token`,
          });
          const socket = io(process.env.VUE_APP_API_URI, {
            path: "/hr-io/socket.io",
            transports: ["websocket"],
            query: { token: data },
            forceNew: true,
          });
          socket.on("connect", () => {
            console.log("Socket connected:", socket.id);
          });
          socket.on("connect_error", (error) => {
            console.error("Socket connection failed:", error.message);
          });
          socket.on("disconnect", (reason) => {
            console.log("Socket disconnected:", reason);
          });
          Vue.use(VueSocketIOExt, socket);
        } catch (error) {
          console.log(error);
        }
        new Vue({
          vuetify,
          router,
          render: (h) => h(App),
        }).$mount("#app");

        // Auto-refresh token every 10s (refresh if <30s to expiry)
        setInterval(() => {
          keycloak.updateToken(30).catch(() => keycloak.login());
        }, 10000);
      }
    });
}
